import DeleteIcon from "@mui/icons-material/Delete";
import { Divider, FormControl, FormControlLabel, IconButton, Radio, RadioGroup } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get } from "lodash";
import React from "react";
import BSInput from "../../../common/js/components/BSInput";

const StyledWrapper = styled("div")({
    display: "flex",
    justifyContent: "space-between",
    gap: "8px",
});

const ExhibitADetail = (props) => {
    const { element, elementIndex, errors, handleUpdateArrayElement, disableInputs, onDelete, handleBlurValidate } =
        props;

    if (get(element, "exhibitAType", null) == null) {
        handleUpdateArrayElement("editableExhibitAs", elementIndex, "exhibitAType", "STANDARD");
    }
    return (
        <React.Fragment>
            {disableInputs !== true && (
                <IconButton
                    sx={{ margin: 0, minWidth: 0, padding: 0 }}
                    onClick={() => {
                        onDelete("editableExhibitAs", elementIndex);
                    }}
                >
                    <DeleteIcon />
                </IconButton>
            )}

            <StyledWrapper>
                <StyledWrapper style={{ minWidth: "50%", marginTop: "15px", marginBottom: "25px" }}>
                    <FormControl rowcomponent="fieldset">
                        <RadioGroup
                            row
                            aria-label="exhibitAType"
                            name="exhibitAType"
                            value={element?.exhibitAType ?? "STANDARD"}
                            onChange={(e) =>
                                handleUpdateArrayElement("editableExhibitAs", elementIndex, e.target.id, e.target.value)
                            }
                        >
                            <FormControlLabel
                                value="STANDARD"
                                control={<Radio id="exhibitAType" color="primary" />}
                                style={{ marginRight: "83px" }}
                                label="Standard"
                            />
                            <FormControlLabel
                                value="PREFERENTIAL"
                                control={<Radio id="exhibitAType" color="primary" />}
                                label="Preferential"
                            />
                        </RadioGroup>
                    </FormControl>
                </StyledWrapper>
            </StyledWrapper>

            <StyledWrapper>
                <BSInput
                    id="baseSplitPercentage"
                    label="BASE SPLIT %"
                    value={element?.baseSplitPercentage ?? null}
                    error={errors?.[`editableExhibitAs.${elementIndex}.baseSplitPercentage`] ?? null}
                    onChange={(e) =>
                        handleUpdateArrayElement("editableExhibitAs", elementIndex, e.target.id, e.target.value)
                    }
                    errorText="Required"
                    endAdornment="%"
                    numeric
                    extraFormControlStyles={{ flex: "0.3 1 0" }}
                    helperText="Required"
                    onBlurValidate={(id, value) =>
                        handleBlurValidate(
                            "exhibitAValidation",
                            `editableExhibitAs.${elementIndex}.baseSplitPercentage`,
                            value
                        )
                    }
                />
                <BSInput
                    id="annualGrossMinimum"
                    label="ANNUAL GROSS MINIMUM $"
                    value={element.annualGrossMinimum !== 0 ? element.annualGrossMinimum : 0}
                    error={errors?.[`editableExhibitAs.${elementIndex}.annualGrossMinimum`] ?? null}
                    onChange={(e) =>
                        handleUpdateArrayElement("editableExhibitAs", elementIndex, e.target.id, e.target.value)
                    }
                    errorText="Required"
                    startAdornment="$"
                    numeric
                    extraFormControlStyles={{ flex: "1 1 0" }}
                    helperText="Required"
                    onBlurValidate={(id, value) =>
                        handleBlurValidate(
                            "exhibitAValidation",
                            `editableExhibitAs.${elementIndex}.annualGrossMinimum`,
                            value
                        )
                    }
                />
                <BSInput
                    id="adjustedPercentage"
                    label="ADJUSTED %"
                    value={element ? element.adjustedPercentage : null}
                    error={errors?.[`editableExhibitAs.${elementIndex}.adjustedPercentage`] ?? null}
                    onChange={(e) =>
                        handleUpdateArrayElement("editableExhibitAs", elementIndex, e.target.id, e.target.value)
                    }
                    errorText="Required"
                    endAdornment="%"
                    numeric
                    extraFormControlStyles={{ flex: "0.3 1 0", marginBottom: "0" }}
                    helperText="Required"
                    onBlurValidate={(id, value) =>
                        handleBlurValidate(
                            "exhibitAValidation",
                            `editableExhibitAs.${elementIndex}.adjustedPercentage`,
                            value
                        )
                    }
                />
            </StyledWrapper>
            <StyledWrapper>
                <BSInput
                    id="exhibitAStartDate"
                    label="START DATE"
                    placeholder="Enter start date"
                    value={element ? element.exhibitAStartDate : null}
                    error={errors?.[`editableExhibitAs.${elementIndex}.exhibitAStartDate`] ?? null}
                    errorText="Enter valid start date"
                    onChange={(e) =>
                        handleUpdateArrayElement("editableExhibitAs", elementIndex, e.target.id, e.target.value)
                    }
                    disabled={disableInputs === true}
                    extraFormControlStyles={{ flex: "1 1 0" }}
                    type="date"

                    onBlurValidate={(id, value) =>
                        handleBlurValidate(
                            "exhibitAValidation",
                            `editableExhibitAs.${elementIndex}.exhibitAStartDate`,
                            value
                        )
                    }
                />
                <BSInput
                    id="exhibitAExpirationDate"
                    label="EXPIRATION DATE"
                    placeholder="Enter expiration date"
                    value={element ? element.exhibitAExpirationDate : null}
                    error={errors?.[`editableExhibitAs.${elementIndex}.exhibitAExpirationDate`] ?? null}
                    onChange={(e) =>
                        handleUpdateArrayElement("editableExhibitAs", elementIndex, e.target.id, e.target.value)
                    }
                    disabled={disableInputs === true}
                    helperText="Required"
                    errorText="Enter valid expiration date"
                    extraFormControlStyles={{ flex: "1 1 0", marginBottom: "0" }}
                    type="date"
                    onBlurValidate={(id, value) =>
                        handleBlurValidate(
                            "exhibitAValidation",
                            `editableExhibitAs.${elementIndex}.exhibitAExpirationDate`,
                            value
                        )
                    }
                />
            </StyledWrapper>

            <BSInput
                id="comments"
                label="COMMENTS"
                placeholder="Enter comments"
                value={element ? element.comments : null}
                multiline
                rows={8}
                margin="normal"
                variant="outlined"
                onChange={(e) =>
                    handleUpdateArrayElement("editableExhibitAs", elementIndex, e.target.id, e.target.value)
                }
            />

            <Divider />
            <br />
        </React.Fragment>
    );
};

export default ExhibitADetail;
